export default "__VITE_ASSET__NU2IWIk8__"